DetailOutput = App.loadClass 'core::reports/DetailOutput'
BaseOutput = App.loadClass 'core::reports/BaseOutput'
BaseHandler = App.loadClass 'core::reports/BaseHandler'

class exports.ReportsPlotsSubHandler extends BaseHandler
    init: () ->
        @layoutSelector = '#reports_plots_tab'
        @filterUrl = 'backend/portal/reports/plots/filters'

        @parent.dialog.find('.excel-btn').hide()

        @initFilters()

    initFilters: () ->
        @resetFilters()

        @parent.filters.importGroup
            name: 'Plots Filters'
            filters: [
                {
                    name: 'brands'
                    display_name: 'Brand'
                    class: 'dropup'
                },
                {
                    name: 'test_types'
                    display_name: 'Test Type'
                    class: 'dropup'
                },
                {
                    name: 'output_type'
                    display_name: 'Output Type'
                    control_type: 'option'
                    deletable: false
                    values: [
                        { key: 'detail', value: 'Detail' },
                        { key: 'summary', value: 'Summary' }
                    ],
                    selected_values: [
                        { key: 'detail', value: 'Detail' }
                    ],
                }
            ]

        #set default to previous year
        @setDefaultsAndRun(-1)


    destroy: () ->
        @parent.filters.removeGroup 'Plots Filters'
        @parent.dialog.find('.excel-btn').show()
        super()

    beforeApply: () ->
        filters = @parent.filters.jsonize()

        if filters.filters.output_type[0].key is 'detail'
            @layoutUrl = 'backend/portal/reports/plots/table/detail'
            @printUrl = 'backend/portal/reports/plots/print/detail'
            @currentOutput = new DetailOutput this, @parent, 900, { sAjaxSource: 'backend/portal/reports/plots/output/detail' }
        else
            @layoutUrl = 'backend/portal/reports/plots/output/summary'
            @printUrl = 'backend/portal/reports/plots/print/summary'
            @currentOutput = new BaseOutput this, @parent, 900
